import { CONTENT_GROUP } from './content-group';
import type { DataLayerEvent } from './data-layer';

/** US goes live without a loyalty programme, so Eataly Club tracking stays out of its plan. */
export function isClubTrackingEnabled(siteId: string): boolean {
    return siteId !== 'USEN';
}

/**
 * Scopes an event to the site's tracking plan. Returns `null` when the event
 * must not reach the data layer on this site.
 */
export function applySiteTrackingPolicy(event: DataLayerEvent, siteId: string): DataLayerEvent | null {
    if (isClubTrackingEnabled(siteId)) {
        return event;
    }

    switch (event.event) {
        case 'eataly_club_click':
            return null;
        case 'share':
            return event.content_type === 'club' ? null : event;
        case 'login':
        case 'sign_up':
            return event.target === 'club' ? { ...event, target: 'shop' } : event;
        case 'page_view':
            return event.content_group === CONTENT_GROUP.CLUB ? { ...event, content_group: '' } : event;
        case 'log_state': {
            const status = event.user_info.membership_status;
            if (status === undefined) {
                return event;
            }
            const membershipStatus = status === 'shop' || status === 'shop_club' ? 'shop' : 'unknown';
            return { ...event, user_info: { ...event.user_info, membership_status: membershipStatus } };
        }
        default:
            return event;
    }
}
